import React from 'react';
import axios from 'axios';
import './LoginForm.css';

const API_URL = 'https://ptlrbackend.onrender.com';

const LoginForm = ({ setToken }) => {
  const handleLogin = async (username, password) => {
    try {
      const response = await axios.post(`${API_URL}/login`, { username, password });
      setToken(response.data.token);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Admin Login</h2>
      <form
        className="login-form"
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin(e.target.username.value, e.target.password.value);
        }}
      >
        <input
          type="text"
          name="username"
          placeholder="Username"
          required
          className="login-input"
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          required
          className="login-input"
        />
        <button type="submit" className="login-button">Login</button>
      </form>
    </div>
  );
};

export default LoginForm;